import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import React from 'react';
import { dataLayerSendEvent, getViewItemListCategory } from 'Epharmacy/EpharmacyAnalytics';
import { PRODUCT_CARD_DEFAULT } from '../../Assets/images';
import {
  HOME_CARE_ROUTE,
  ONE_ASTER_CATEGORY_HOME,
  ONLINE_PHARMACY_ROUTE,
  SPECIALITY_URL,
  TELECONSULT_ROUTE,
} from '@common/Utility/constants';
import { sendEventToSmartLook } from '@common/Utility/smartlook';
import SectionBox from '../SectionBox/SectionBox';
import { EightInOneStyled } from './EightInOneStyled';
import { doctorSpecialityClick } from '../BookAppointment/BookingFunnelAnalytics';
import { viewAllLinkClick } from '@common/Utility/analytics-utils';
import withAnalytics from '../Hoc/WithAnalytics';
import { getImageUrlWithSize } from '@common/Utility/common-utils';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { useTranslation } from '@common/i18n';

const CategoryItem = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const { analyticsProps, showTitles = true } = props;

  const navigateToListingPage = () => {
    if (props?.sectionName === 'Doctor Specialities' && props?.categoryId !== '') {
      router.push({ pathname: generateURL(`${TELECONSULT_ROUTE}/s/${props?.categoryId}`) });
    } else if (
      (props?.sectionName === 'Pharmacy Featured Categories' || props?.sectionName === 'Pharmacy Popular Categories') &&
      props?.categoryId !== ''
    ) {
      router.push({ pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${props?.categoryId}`) });
    } else if (props?.sectionName === 'Homecare Service Categories' && props?.categoryId !== '') {
      router.push({ pathname: generateURL(`${HOME_CARE_ROUTE}/services/${props?.categoryId}`) });
    }

    if (props?.sectionName === 'Doctor Specialities') {
      doctorSpecialityClick(props?.pageName, 'homepage', '', props?.name, props?.title, props?.pageName);
    } else if (!props?.sectionName) {
      router.push({ pathname: generateURL(`${props?.categoryId}`) });
    } else {
      const matchingDataItem = props.data.find((item) => item.categoryName === props.name);
      const categoryId = matchingDataItem.id;

      const bannerProps = {
        section_name: props?.title,
        item_id: String(categoryId),
        item_name: props?.name.replace(/\s+/g, ' '),
        item_url: props?.categoryId,
        referrer_page: props?.referrerPage,
        page_type: props?.pageType,
        position: props?.position+1,
      };
      const specificProps = {
        screen_name: router?.query?.slugname
          ? router?.query?.slugname
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
          ? 'epharmacy homepage'
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
          ? 'asco homepage'
          : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
          ? 'doctor consult homepage'
          : props?.pageName,
      };
      if (analyticsProps && Object.keys(analyticsProps).length !== 0) {
        dataLayerSendEvent('item_selected', { ...analyticsProps, ...bannerProps });
      } else {
        dataLayerSendEvent('item_selected', { ...specificProps, ...bannerProps }); 
      }

      const properties = {
        type: props?.name,
      };
      sendEventToSmartLook('item_selected', properties);
    }
  };

  const { sectionName, categoryId } = props;
  let href = '';

  if (sectionName === 'Doctor Specialities' && categoryId !== '') {
    href = `${TELECONSULT_ROUTE}/s${categoryId}`;
  } else if (
    (sectionName === 'Pharmacy Featured Categories' || sectionName === 'Pharmacy Popular Categories') &&
    categoryId !== ''
  ) {
    href = `${ONLINE_PHARMACY_ROUTE}/${categoryId}`;
  } else if (sectionName === 'Homecare Service Categories' && categoryId !== '') {
    href = `${HOME_CARE_ROUTE}/services/${categoryId}`;
  }

  return (
    <Link href={generateURL(href)} passHref>
      <a
        className={`categoryItemBox ${props.customClass}`}
        onClick={(e) => {
          e.preventDefault();
          if (props?.categoryId !== '' && props?.categoryId !== undefined && props?.categoryId !== null) {
            navigateToListingPage();
          }
        }}
      >
        <div className="item">
          <div className="img">
            <Image
              data-test="div_2"
              src={getImageUrlWithSize(props?.categoryImage, 100, 100) || PRODUCT_CARD_DEFAULT.src}
              alt={props?.name}
              width="100px"
              height="100px"
              unoptimized
            />
          </div>
          {showTitles && <div className="name line-clamp w-100">{props?.name}</div>}
        </div>
      </a>
    </Link>
  );
};

const EightInOne = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const t = useTranslation();
  const { analyticsProps, singleLine = true, showTitles = true } = props;
  const inViewRef = useRef();
  const bannerViewEventFired = useRef();

   const sendViewItemListEvent = (responseData) => {
     if (!responseData) return;
     dataLayerSendEvent('view_item_list', {
      screen_name: router?.query?.slugname
      ? router?.query?.slugname
      : props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
      ? 'epharmacy homepage'
      : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
      ? 'asco homepage'
      : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
      ? 'doctor consult homepage'
      : props?.pageName,
       page_type: props?.pageType,
       referrer_page: props?.referrerPage,
       myaster_category: 'epharmacy',
       section_name: props?.title,
       ecommerce: {
         items: props?.data?.map((item, index) => {
           return { ...getViewItemListCategory(item), position: index + 1 };
         }),
       },
     });
     sendEventToSmartLook('view_item_list');
   };

   const handleOnView = () => {
     if (!bannerViewEventFired.current && props?.data && (props?.sectionName=== 'Pharmacy Featured Categories' || props?.sectionName=== 'Pharmacy Popular Categories')) {
       bannerViewEventFired.current = true;
       sendViewItemListEvent(props?.data);
     }
   };

  const navigateToSpecificRoute = () => {
    if (props?.sectionName === 'Doctor Specialities') {
      router.push({ pathname: generateURL(`${TELECONSULT_ROUTE}/${SPECIALITY_URL}`) });
      viewAllLinkClick(props?.pageName, props?.title);
    } else if (props?.sectionName === 'Pharmacy Featured Categories' && props?.linkWebViewAll != "" && props?.linkWebViewAll != null) {
      if (props?.viewAll && props?.linkWebViewAll) {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${props?.linkWebViewAll}`)
        });
      } 
    } else if (props?.sectionName === 'Pharmacy Popular Categories' && props?.linkWebViewAll != "" && props?.linkWebViewAll != null) {
      if (props?.viewAll && props?.linkWebViewAll) {
        router.push({
          pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${props?.linkWebViewAll}`)
        });
      } 
    } else if (props?.sectionName === 'Homecare Service Categories') {
      router.push({
        pathname: generateURL(`${HOME_CARE_ROUTE}/services`),
        query: { title: props?.title },
      });
    }
  };

  const getDynamiClassName = () => {
    if (props?.sectionName === 'Pharmacy Featured Categories' || props?.sectionName === 'Pharmacy Popular Categories') {
      return 'ePharmacy';
    }
    if (props?.sectionName === 'Homecare Service Categories') {
      return 'homeCare';
    }
    return '';
  };

  const { sectionName, title } = props;
  let hrefValue = '';

  if (sectionName === 'Doctor Specialities') {
    hrefValue = { pathname: generateURL(`${TELECONSULT_ROUTE}/${SPECIALITY_URL}`) };
  } else if (sectionName === 'Pharmacy Featured Categories' && props?.linkWebViewAll != "" && props?.linkWebViewAll != null) {
    const queryTitle =
      title || (sectionName === 'Pharmacy Featured Categories');
    if (props?.viewAll && props?.linkWebViewAll) {
      hrefValue = {
        pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${props?.linkWebViewAll}`)
      }
    }
  } else if (sectionName === 'Pharmacy Popular Categories' && props?.linkWebViewAll != "" && props?.linkWebViewAll != null) {
    const queryTitle =
      title || (sectionName === 'Popular Categories');
    if (props?.viewAll && props?.linkWebViewAll) {
      hrefValue = {
        pathname: generateURL(`${ONLINE_PHARMACY_ROUTE}/${props?.linkWebViewAll}`)
      }
    }
  } else if (sectionName === 'Homecare Service Categories') {
    hrefValue = { pathname: generateURL(`${HOME_CARE_ROUTE}/services`), query: { title } };
  }

  const viewAllLinkClickEvent = () => {
    if (props?.sectionName === 'Pharmacy Featured Categories' || props?.sectionName === 'Pharmacy Popular Categories') {
      dataLayerSendEvent('view_all_link_click', {
        screen_name: router?.query?.slugname
        ? router?.query?.slugname
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.PHARMACY
        ? 'epharmacy homepage'
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.CORE
        ? 'asco homepage'
        : props?.pageName === ONE_ASTER_CATEGORY_HOME?.DOCTOR
        ? 'doctor consult homepage'
        : props?.pageName,
        page_type: props?.pageType,
        page_id: null,
        myaster_category: 'epharmacy',
        section_name: props?.title,
        type: 'category carousel',
      });
      sendEventToSmartLook('view_all_link_click');
    }
  };
 
  const getRightTopContent = () => {
    if (props?.data?.length > 6 && props?.sectionName && props?.viewAll) {
      return (
        <Link href={hrefValue} passHref>
          <a
            className="link me-2"
            role="button"
            aria-pressed="false"
            tabIndex="0"
            onClick={() => {
              viewAllLinkClickEvent();
              navigateToSpecificRoute();
            }}
          >
            {t('EPharmacyHome.viewAll')}
          </a>
        </Link>
      );
    } else if (props?.data?.length > 6 && !props?.sectionName) {
      if (props?.linkWebViewAll && props?.viewAll) {
        return (
          <Link href={generateURL(props?.linkWebViewAll)} passHref>
            <a
              className="link me-2"
              role="button"
              aria-pressed="false"
              tabIndex="0"
              onClick={() => {
                viewAllLinkClickEvent();
                router.push({ pathname: generateURL(props?.linkWebViewAll) });
              }}
            >
              {t('EPharmacyHome.viewAll')}
            </a>
          </Link>
        );
      } else {
        return null;
      }
    }

    return null;
  };

  const renderCategoryItems = () => {
    if (!props?.data?.length) return null;
  
    return (
        <SectionBox
          title={props?.title}
          customClass={getDynamiClassName()}
          customOuterClass="sectionBox whiteBg pb-2"
          rightTop={getRightTopContent()}
          bgColor={props?.bgColor}
        >
          <div className="d-flex flex-ItemBox-wrap justify-content-center">
            {props?.data?.map((item, id) => (
              <CategoryItem
                {...props}
                position={id}
                key={id}
                categoryId={item?.linkWeb}
                categoryImage={item?.imageWeb}
                name={item?.categoryName}
                customClass="newDesign large"
                analyticsProps={analyticsProps}
                showTitles={showTitles}
              />
            ))}
          </div>
        </SectionBox>
    );
  };
  
  const CategoryItemsWithAnalytics = withAnalytics(
    () => (
      <EightInOneStyled ref={inViewRef} bgColor={props?.bgColor} title={props?.title} viewAll={props?.viewAll} imageShape={props?.imageShape}>
        {renderCategoryItems()}
      </EightInOneStyled>
    ),
    handleOnView,
    inViewRef,
  );
  
  return <CategoryItemsWithAnalytics />;
  };

CategoryItem.propTypes = {
  categoryImage: PropTypes.string,
  name: PropTypes.string,
  categoryId: PropTypes.string,
  position: PropTypes.any,
  pageName: PropTypes.string,
  sectionName: PropTypes.string,
  customClass: PropTypes.string,
  title: PropTypes.string,
  analyticsProps: PropTypes.object
};

CategoryItem.defaultProps = {
  categoryImage: '',
  name: '',
  pageName: '',
  sectionName: '',
  customClass: '',
};

EightInOne.defaultProps = {
  title: '',
  pageName: '',
  sectionName: '',
  imageShape:'',
};

EightInOne.propTypes = {
  props: PropTypes.any,
  setLoading: PropTypes.any,
  popularApi: PropTypes.any,
  title: PropTypes.string,
  pageName: PropTypes.string,
  sectionName: PropTypes.string,
  data: PropTypes.any,
  viewAll: PropTypes.bool,
  linkWebViewAll: PropTypes.string,
  analyticsProps: PropTypes.object,
  imageShape: PropTypes.string,
};

export default EightInOne;
